import React from 'react'
import { Col, Form } from 'antd'
import { useStep } from 'hooks'
import { PercentageInput } from 'components'

type PercentageInsuredProps = {
  numberInsured: 'FirstInsured' | 'SecondInsured',
  readOnlyInput?: boolean,
  errors: any
}

function PercentageInsured ({ numberInsured, errors, readOnlyInput }: PercentageInsuredProps) {
  const step = useStep()
  const insuredNumber: number = numberInsured === 'FirstInsured' ? 1 : 2
  const isCreditAnalysis = step.slug === 'analise-de-credito'

  return (
    <Col lg={12} xs={24}>
      <Form.Item
        name={`percentageFor${numberInsured}`}
        label={<label>Porcentagem para Segurado {insuredNumber}</label>}
        help={errors[`percentageFor${numberInsured}`] && (errors[`percentageFor${numberInsured}`])}
        validateStatus={errors[`percentageFor${numberInsured}`] && ('error')}
        rules={[{ required: isCreditAnalysis, message: 'Campo obrigatório' }]}
      >
        <PercentageInput
          disabled={readOnlyInput}
          emptyDefault
          placeholder={`Porcentagem para Segurado ${insuredNumber}`}
        />
      </Form.Item>
    </Col>
  )
}

export default PercentageInsured
